import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { HOUSELINKS } from '../../../../data/constants'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      {/* <div className='mt-10'></div> */}
      {/* <AsideMenuItem
        to='/dashboard/summary'
        icon='/assets/media/icons/duotune/general/gen025.svg'
        title='Dashboard'
        fontIcon='bi-layers'
      /> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>NIRA ID Verification</span>
        </div>
      </div>

      <AsideMenuItem
        to='/nira/biometrics'
        icon='/assets/media/icons/duotune/technology/teh004.svg'
        title='Via Biometrics (new)'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='nira/form'
        icon='/assets/media/icons/duotune/finance/fin002.svg'
        title='Via Form Entry (old)'
        fontIcon='bi-layers'
      />
      
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Enhanced KYC Verification</span>
        </div>
      </div>
      <AsideMenuItem
        to='/account/overview'
        icon='/assets/media/icons/duotune/electronics/elc002.svg'
        title='Phone Number'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/account/settings'
        icon='/assets/media/icons/duotune/finance/fin001.svg'
        title='Business Search'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/abstract/abs037.svg'
        title='MTN SIM Swap'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/ecommerce/ecm003.svg'
        title='TIN'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/abstract/abs027.svg'
        title='AML/CFT & PEP Screening'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/communication/com011.svg'
        title='Email Verification'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/maps/map009.svg'
        title='KCCA Trade License'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/technology/teh002.svg'
        title='Face Matching'
        fontIcon='bi-layers'
      /> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Administration</span>
        </div>
      </div>
      <AsideMenuItem
        to='/account/settings'
        icon='/assets/media/icons/duotune/coding/cod001.svg'
        title='NIRA Settings'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/settings/configs'
        icon='/assets/media/icons/duotune/technology/teh008.svg'
        title='User Management'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>HELP</span>
        </div>
      </div>
      <AsideMenuItem
        to='/help/support'
        icon='/assets/media/icons/duotune/general/gen011.svg'
        title='Support Center'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/help/documentation'
        icon='/assets/media/icons/duotune/general/gen046.svg'
        title='Documentation'
        fontIcon='bi-layers'
      />
    </>
  )
}
